import React, { useEffect, useState } from 'react'
import HomePage from 'components/templates/navigationPageTemplates/HomePage'
import { Grid, Typography } from '@mui/material'
import NotificationSettings from 'components/organisms/user/NotificationSettings'
import CalendarSettings from 'components/organisms/user/CalendarSettings'
import BillingSettings from 'components/organisms/user/BillingSettings'
import LearningPathReminderSettings from 'components/organisms/user/LearningPathReminderSettings'
import { getStates } from 'services/userServices'
import {
  ContainerLarge,
  ParentGridContainer
} from 'components/atoms/container/ResponsiveContainers'
import SidebarMenu from 'components/atoms/container/SidebarMenu'
import { useTranslation } from 'react-i18next'
import { ColStack } from 'components/atoms/container/InCardStack'
import { permitted, isAllowedFeature } from 'utils/permissionCheck'
import { PERMISSION_LEVEL } from 'routes/constants'
import { FEATURE_KEYS } from 'services/constants'
import SectionDivider from 'components/atoms/SectionDivider'

const UserSettings = () => {
  const { t } = useTranslation()
  const [userStates, setUserStates] = useState(null)
  const [activeTab, setActiveTab] = useState(0)
  const hasLicense =
    permitted(PERMISSION_LEVEL.LICENSED) ||
    isAllowedFeature(FEATURE_KEYS.ONE_ON_ONE_PAID)

  const TABS = [
    t('settings.notifications'),
    t('calendarEvents.calendar'),
    ...(hasLicense ? [t('settings.billingPlan')] : [])
  ]

  useEffect(() => {
    const fetchData = async () => {
      const resData = await getStates()
      setUserStates(resData)
    }
    fetchData()
  }, [])

  return (
    <HomePage customizedBodyWidth={true}>
      <ContainerLarge>
        <ParentGridContainer>
          <Grid size={3}>
            <SidebarMenu
              tabLabels={TABS}
              initialActive={activeTab}
              onTabChange={setActiveTab}
              containerSx={{
                pt: 24,
                pr: 8
              }}
            />
          </Grid>
          <Grid size={{ xs: 9, sm: 9, md: 8 }}>
            <ColStack spacing={12} paddingBottom={20}>
              <Typography variant='h1'>
                {t('headers.settings')} - {TABS[activeTab]}
              </Typography>

              {activeTab === 0 ? (
                <>
                  <NotificationSettings userStates={userStates} />
                  <SectionDivider />
                  <LearningPathReminderSettings userStates={userStates} />
                </>
              ) : activeTab === 1 ? (
                <CalendarSettings />
              ) : (
                <BillingSettings />
              )}
            </ColStack>
          </Grid>
        </ParentGridContainer>
      </ContainerLarge>
    </HomePage>
  )
}

export default UserSettings
